import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id E76EC23F-AB71-49B3-9173-841544527A20
 * name account
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account.svg
 * tags
 * - Account / User 
 * - Home Automation 
 */
export const AccountIcon = createSvgIcon(<><path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" /></>, 'AccountIcon');
export default AccountIcon